'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Spritesheet = function Spritesheet(_ref) {
    var defs = _ref.defs,
        symbols = _ref.symbols;

    var defsKeys = (0, _keys2.default)(defs);

    return _react2.default.createElement(
        'svg',
        {
            xmlns: 'http://www.w3.org/2000/svg',
            style: { display: 'none' }
        },
        defsKeys.length > 0 && _react2.default.createElement(
            'defs',
            null,
            defsKeys.map(function (k) {
                return _react2.default.cloneElement(defs[k](), { id: k, key: k });
            })
        ),
        (0, _keys2.default)(symbols).map(function (k) {
            return _react2.default.cloneElement(symbols[k](), { id: k, key: k });
        })
    );
};

Spritesheet.propTypes = {
    defs: _propTypes2.default.object.isRequired, // eslint-disable-line react/forbid-prop-types
    symbols: _propTypes2.default.object.isRequired // eslint-disable-line react/forbid-prop-types
};

exports.default = Spritesheet;
//# sourceMappingURL=Spritesheet.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/ui-svg/lib/cjs/components/Spritesheet.js
 ** module id = 344
 ** module chunks = 0
 **/